import React from "react";

import MatchItemPreview from "./MatchItemPreview";
import MatchButtonBox from "./MatchButtonBox";
import styled from "styled-components";
import { useGetChattingRoomInfo } from "@src/hooks/auctionAgent/chat";
import IcoClose from "@src/assets/LeftIcon.png";
import { transferToNative } from "@src/lib/WebAppBridge";
import MatchStatus from "./MatchStatus";
import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";

export type MatchUserType = "user" | "taker";

const ChattingRoomInfo = () => {
    const { chattingRoomFromContext: chattingRoomInfoFromContext } = useChattingRoomFromContext();
    const { data: chattingRoomInfo } = useGetChattingRoomInfo(
        chattingRoomInfoFromContext?.chattingRoomNo ?? 0,
        !!chattingRoomInfoFromContext?.chattingRoomNo && chattingRoomInfoFromContext?.chattingRoomNo !== 0,
    );

    const onClickClose = () => {
        transferToNative("done", "closeWebView");
    };

    if (!chattingRoomInfo || !chattingRoomInfoFromContext) return null;
    return (
        <>
            <TitleBox>
                <button className="close-icon" onClick={onClickClose}>
                    <img src={IcoClose} alt="close" />
                </button>
                <div className="title">{chattingRoomInfo?.otherUser?.name}</div>
            </TitleBox>
            <ChattingRoomInfoBox>
                {chattingRoomInfo?.matchStatus && (
                    <MatchStatus status={chattingRoomInfo?.matchStatus} userType={chattingRoomInfoFromContext?.user.userType} />
                )}
                {chattingRoomInfo?.item && <MatchItemPreview item={chattingRoomInfo?.item} />}
                <MatchButtonBox
                    userType={chattingRoomInfoFromContext?.user.userType}
                    matchRequestNo={chattingRoomInfo?.matchRequestNo ?? 0}
                />
            </ChattingRoomInfoBox>
        </>
    );
};

export default ChattingRoomInfo;

const ChattingRoomInfoBox = styled.div`
    display: flex;
    justify-content: center;

    flex-direction: column;
    gap: 8px;
    padding: 14px;
    border-bottom: 8px solid #f2f3f6;
`;

const TitleBox = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 56px;
    border-radius: 0px;
    padding: 14px;
    border-bottom: 1px solid #dadada;

    & .title {
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        color: #0c002c;
    }

    & .close-icon {
        position: absolute;
        left: 14px;
        top: 50%;
        transform: translateY(-50%);
        height: 18px;

        img {
            width: 10px;
            height: 18px;
        }
    }
`;
